// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"114":"page-product-detail","326":"page-solidway-products","387":"page-solidway-product-detail","565":"layout-main"}[chunkId] || chunkId) + "." + {"114":"01978989","326":"d37b80f5","387":"ff1da646","424":"01978989","565":"40bc2e2f"}[chunkId] + ".css";
};